(function () {
  'use strict';

  const tables = document.querySelectorAll('.bsb-ab__table');
  const updateTableFocus = (wrap) => {
    if (wrap.scrollWidth > wrap.clientWidth) {
      wrap.setAttribute('tabindex', '0');
    } else {
      wrap.removeAttribute('tabindex');
    }
  };
  tables.forEach(updateTableFocus);

  document.querySelectorAll('.bsb-ab').forEach((root) => {
    const lightbox = root.querySelector('.bsb-lb');
    if (!lightbox) return;
    const images = Array.from(root.querySelectorAll('.bsb-ab__content img')).filter((img) => !img.closest('a'));
    const open = (index) => {
      if (!window.bsbLightbox) return;
      const slides = images.map((img) => ({ src: img.currentSrc || img.src, alt: img.alt }));
      window.bsbLightbox.open(lightbox, slides, index, images[index]);
    };
    images.forEach((img, index) => {
      img.classList.add('bsb-ab__zoom');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', img.alt ? `View larger: ${img.alt}` : 'View larger image');
      img.addEventListener('click', () => open(index));
      img.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(index);
      });
    });
  });
  if (tables.length && 'ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => updateTableFocus(entry.target));
    });
    tables.forEach((wrap) => resizeObserver.observe(wrap));
  }

  document.querySelectorAll('[data-bsb-ab-toc]').forEach((toc) => {
    const list = toc.querySelector('ul');
    document.querySelectorAll('[data-bsb-toc-label]').forEach((section) => {
      if (!section.id) return;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'bsb-ab__toc-link';
      link.href = `#${section.id}`;
      link.setAttribute('data-bsb-ab-toc-link', '');
      link.textContent = section.dataset.bsbTocLabel;
      item.appendChild(link);
      list.appendChild(item);
    });

    const targetOf = (link) => document.getElementById(decodeURIComponent(link.hash.slice(1)));
    Array.from(list.children)
      .map((item) => ({ item, target: targetOf(item.querySelector('a')) }))
      .filter((entry) => entry.target)
      .sort((a, b) => (a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1))
      .forEach((entry) => list.appendChild(entry.item));

    const links = Array.from(toc.querySelectorAll('[data-bsb-ab-toc-link]'));
    const headings = links
      .map(targetOf)
      .filter(Boolean);
    if (!headings.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const passed = new Map(headings.map((heading) => [heading, false]));
    let lockedUntilScrollEnd = false;
    let unlockTimer = null;

    const setActive = (target) => {
      links.forEach((link) => {
        if (targetOf(link) === target) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const updateFromScroll = () => {
      if (lockedUntilScrollEnd) return;
      let current = headings[0];
      headings.forEach((heading) => {
        if (passed.get(heading)) current = heading;
      });
      setActive(current);
    };

    const unlock = () => {
      lockedUntilScrollEnd = false;
      clearTimeout(unlockTimer);
    };

    toc.addEventListener('click', (event) => {
      const link = event.target.closest('[data-bsb-ab-toc-link]');
      if (!link) return;
      const target = targetOf(link);
      if (!target) return;
      event.preventDefault();
      setActive(target);
      lockedUntilScrollEnd = true;
      clearTimeout(unlockTimer);
      unlockTimer = setTimeout(unlock, 1200);
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      history.pushState(null, '', link.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });

    window.addEventListener('scrollend', unlock);
    window.addEventListener('wheel', unlock, { passive: true });
    window.addEventListener('touchstart', unlock, { passive: true });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const line = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight * 0.3;
          passed.set(entry.target, entry.boundingClientRect.top < line);
        });
        updateFromScroll();
      },
      { rootMargin: '0px 0px -70% 0px', threshold: [0, 1] }
    );

    headings.forEach((heading) => observer.observe(heading));
  });
})();
